module.exports = __webpack_public_path__ + "static/media/rover.b7e7233c.svg";